import gql from "graphql-tag";
import { pick } from "lodash";
import { Org } from "./types";
import {
  orgFieldsFragment,
  userFieldsFragment,
  userOrOrgProjectResultsFragment,
} from "./fragments";

export const orgQuery = gql`
  query org($id: ID, $shortname: String, $withProjects: Boolean = false) {
    org(id: $id, shortname: $shortname) {
      ...OrgFields
      projects @include(if: $withProjects) {
        ...UserOrOrgProjectResultsFields
      }
    }
  }
  ${orgFieldsFragment}
  ${userOrOrgProjectResultsFragment}
`;

export const addOrgMutation = gql`
  mutation addOrg($data: OrgInput!, $addCreator: Boolean) {
    addOrg(data: $data, addCreator: $addCreator) {
      ...OrgFields
    }
  }
  ${orgFieldsFragment}
`;

export const updateOrgMutation = gql`
  mutation updateOrg($id: ID!, $data: OrgInput!) {
    updateOrg(orgId: $id, data: $data) {
      ...OrgFields
    }
  }
  ${orgFieldsFragment}
`;

export const removeMeFromOrgMutation = gql`
  mutation removeMeFromOrg($orgId: ID!) {
    removeMeFromOrg(orgId: $orgId) {
      ...OrgFields
    }
  }
  ${orgFieldsFragment}
`;

export const updateMyJobTitleMutation = gql`
  mutation updateMyJobTitle($orgId: ID!, $jobTitle: String) {
    updateMyJobTitle(orgId: $orgId, jobTitle: $jobTitle) {
      ...OrgFields
    }
  }
  ${orgFieldsFragment}
`;

export const addUserToOrgMutation = gql`
  mutation addUserToOrg($orgId: ID!, $userId: ID!, $roleId: ID) {
    addUserToOrg(orgId: $orgId, userId: $userId, roleId: $roleId)
  }
`;

export const removeUserFromOrgMutation = gql`
  mutation removeUserFromOrg($orgId: ID!, $userId: ID!) {
    removeUserFromOrg(orgId: $orgId, userId: $userId) {
      ...OrgFields
    }
  }
  ${orgFieldsFragment}
`;

export const updateUserOrgRoleMutation = gql`
  mutation updateUserOrgRole(
    $orgId: ID!
    $userId: ID!
    $roleId: ID
    $jobTitle: String
  ) {
    updateUserOrgRole(
      orgId: $orgId
      userId: $userId
      roleId: $roleId
      jobTitle: $jobTitle
    ) {
      ...OrgFields
    }
  }
  ${orgFieldsFragment}
`;

export const orgInputFields = (org: Org) => {
  return pick(org, [
    "name",
    "address",
    "location",
    "description",
    "legalName",
    "nonProfit",
    "publicMembership",
    "supportContact",
    "url",
  ]);
};

export const getAllOrgNames = gql`
  query allOrgNames {
    orgs {
      id
      name
      shortname
    }
  }
`;

export const getOrgsQuery = gql`
  query allOrgs {
    orgs {
      id
      name
      address {
        postOfficeBoxNumber
        streetAddress
        addressLocality
        addressRegion
        addressCountry
        postalCode
      }
      projectCount
      location
      description
      legalName
      shortname
      members {
        id
        image
        givenName
        familyName
        fullName
        shortname
        email
        memberOf {
          org {
            id
          }
          jobTitle
          role {
            id
            name
          }
        }
      }
      parentOrganization {
        id
        name
        logo
      }
      roles {
        id
        name
      }
      nonProfit
      supportContact
      publicMembership
      logo
      avatar
      image
      url
      createdAt
      updatedAt
      memberCount
    }
  }
`;
